import React from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';

import { numberToCurrency } from './util';

const { cx } = cxHelpers('TipOut');

const TipOut = ({ tipOut }) => (
  <Box className={cx()} column>
    <Box w={100}>
      <Text
        color="mono700"
        textAlign="left"
        variant="bodySmBoldTight"
        i18n="timecard_modal_v3.tips_edit_section.tip_out"
      />
      <Box vcenter pv={16}>
        <Text variant="body" color="mono900">
          {numberToCurrency(tipOut ?? 0)}
        </Text>
      </Box>
    </Box>
  </Box>
);

TipOut.propTypes = {
  tipOut: PropTypes.number,
};

export default TipOut;
